import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";
import { useState } from "react";

import { Button } from "@/components/ui/button/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/dropdown-menu";
import { Loan } from "./schema";
// import { useTakeActionModal } from "../take-action-modal/use-action-modal";
// import { useDeleteLoanModal } from "../delete-load-modal/use-delete-loan-modal";
import { Link } from "react-router-dom";
import { useTakeActionModal } from "../take-action-modal/use-action-modal";
import { useDeleteLoanModal } from "../delete-load-modal/use-delete-loan-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as Loan;

  const [open, setOpen] = useState(false);

  const { onOpenChange, setLoan } = useTakeActionModal();
  const { onOpenChange: onDeleteModalChange, setLoanId } = useDeleteLoanModal();

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
        >
          <DotsHorizontalIcon className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        {originData?.status === "Approved" && (
          <DropdownMenuItem>
            <Link
              to={`/admin/other-loans/${originData?.id}`}
              className="w-full h-full"
            >
              View Loan
            </Link>
          </DropdownMenuItem>
        )}
        {originData?.status === "Pending" && (
          <DropdownMenuItem
            onMouseDown={() => {
              setLoan(originData);
              onOpenChange(true);
              setOpen(false);
            }}
          >
            Take Action
          </DropdownMenuItem>
        )}

        <DropdownMenuItem
          onMouseDown={() => {
            setLoanId(originData?.id);
            onDeleteModalChange(true);
            setOpen(false);
          }}
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
